import api from '../../lib/api';
import type { IsoStandard } from '../../constants/isoStandards';

export async function fetchEnabledStandards(): Promise<IsoStandard[]> {
  const { data } = await api.get<{ enabledStandards: IsoStandard[] }>(
    'organization/enabled-standards',
  );
  return data.enabledStandards;
}

export async function updateEnabledStandards(
  enabledStandards: IsoStandard[],
): Promise<IsoStandard[]> {
  const { data } = await api.put<{ enabledStandards: IsoStandard[] }>(
    'organization/enabled-standards',
    { enabledStandards },
  );
  return data.enabledStandards;
}
